module.exports = __webpack_public_path__ + "static/media/a.d4b8e040.png";